/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SequenceFeatureTypeColorSetting } from './SequenceFeatureTypeColorSetting';
import {
    SequenceFeatureTypeColorSettingFromJSON,
    SequenceFeatureTypeColorSettingFromJSONTyped,
    SequenceFeatureTypeColorSettingToJSON,
} from './SequenceFeatureTypeColorSetting';

/**
 * Color specified by default or updated by a user for either a feature type of feature name
 * @export
 * @interface SequenceFeatureColor
 */
export interface SequenceFeatureColor {
    /**
     * 
     * @type {number}
     * @memberof SequenceFeatureColor
     */
    featureTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof SequenceFeatureColor
     */
    label?: string;
    /**
     * hex color
     * @type {string}
     * @memberof SequenceFeatureColor
     */
    color?: string;
    /**
     * 
     * @type {SequenceFeatureTypeColorSetting}
     * @memberof SequenceFeatureColor
     */
    setting?: SequenceFeatureTypeColorSetting;
    /**
     * True when a color has been created by a user
     * @type {boolean}
     * @memberof SequenceFeatureColor
     */
    ownedByUser?: boolean;
}

/**
 * Check if a given object implements the SequenceFeatureColor interface.
 */
export function instanceOfSequenceFeatureColor(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "featureTypeId" in value;

    return isInstance;
}

export function SequenceFeatureColorFromJSON(json: any): SequenceFeatureColor {
    return SequenceFeatureColorFromJSONTyped(json, false);
}

export function SequenceFeatureColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): SequenceFeatureColor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'featureTypeId': json['featureTypeId'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'setting': !exists(json, 'setting') ? undefined : SequenceFeatureTypeColorSettingFromJSON(json['setting']),
        'ownedByUser': !exists(json, 'ownedByUser') ? undefined : json['ownedByUser'],
    };
}

export function SequenceFeatureColorToJSON(value?: SequenceFeatureColor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'featureTypeId': value.featureTypeId,
        'label': value.label,
        'color': value.color,
        'setting': SequenceFeatureTypeColorSettingToJSON(value.setting),
        'ownedByUser': value.ownedByUser,
    };
}

